
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"onDemand.title":"Bitte Daten laden oder Filter bearbeiten","onDemand.load-data":"Daten laden"},"en":{"onDemand.title":"Load data or edit filters","onDemand.load-data":"Load data"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();